"use strict";

var $ = require('lc-jquery');

/**
 * Handles messages to be displayed
 * Use in conjunction with notification-box.hbs in the HBS template.
 * Will work standalone, but for styling notification box assumes
 * it is in a snowflake driven page
 *
 * @param {jQuery} container - element to put server error message in
 * @params {object} options
 *         options.timedClose: [optional] milliseconds at integer.
 *           if truthy, will auto collapse the box after this amount of time
 *         options.closeButton: [optional] boolean. If true, show an 'x'
 *           button so user can manually collapse notification if desired
 */

/**
 * Handles showing errors to the user returned from the server
 */
function NotificationBox(container, options) {
  this.options = options || {};
  this.container = $(container);
  this.messageContainer = this.container.find('[data-notification-message]');
  this.icon = this.container.find('[data-notification-icon]');
  this.alertContainer = this.container.find('[data-notification-alert]');
  this.iconClass = '';
  this.updateIcon('hidden');
  if (this.options.closeButton) {
    this.initCloseButton();
  }
}
NotificationBox.prototype.initCloseButton = function initCloseButton() {
  this.closeButton = this.container.find('[data-notification-close]');
  this.closeButton.removeClass('hidden');
  this.closeButton.on('click', $.proxy(this.collapse, this));
};

/**
 * update icon by removing any optional old classes and applying new ones
 *
 * @param {string} iconClass - css class to add to icon
 */
NotificationBox.prototype.updateIcon = function updateIcon(iconClass) {
  if (this.iconClass) {
    this.icon.removeClass(this.iconClass);
  }
  this.icon.addClass(iconClass);
  this.iconClass = iconClass;
};

/**
 * hides the notification box with css animation,
 * set style back to defaults, removes contents
 *
 * @param <none>
 */
NotificationBox.prototype.collapse = function collapse() {
  this.messageContainer.empty();
  this.container.addClass('collapsed');
  this.alertContainer.removeClass('alert-error alert-success');
};

/**
 * reveals the container with CSS animation
 *
 * @param {String} alertClass - optional. error or success class
 *        to add to container
 */
NotificationBox.prototype.expand = function expand(alertClass) {
  if (alertClass) {
    this.alertContainer.addClass(alertClass);
  }
  this.container.removeClass('collapsed');
};

/**
 * normalize errors to be an array of objects with `message` property
 *   assumes errors come in one of three ways:
 *     1. singular string
 *     2. array of objects, each with `message` and `error` property
 *     3. singular object with `message` and `error` property
 *        e.g., {error: 'ERROR_KEY', message: 'text of error message'}
 *
 * @param {String or Array} errors - an array or string of error objects
 *        containing a message key
 *
 * returns normalized array of errors with `message` and `error` property
 */
NotificationBox.prototype.normalizeErrors = function normalizeErrors(errors) {
  var normalized = [];
  if (typeof errors === 'string') {
    normalized.push({
      message: errors,
      error: ''
    });
  } else if (errors instanceof Array) {
    // this will accept an arrays of objects with `message`
    // properties as well as arrays of strings
    errors.forEach(function (error) {
      normalized.push({
        message: error.message || error,
        error: error.error || ''
      });
    });
  } else {
    // errors is a singular object
    normalized.push({
      message: errors.message,
      error: errors.error || ''
    });
  }
  return normalized;
};

/**
 * Show error message[s] to user
 *
 * @param {String or Array} errors - an array or string of error objects
 *        containing a message key
 * @param {integer} timedClose - the box will collapse after this amount of time
 */
NotificationBox.prototype.showErrors = function showErrors(errors, timedClose) {
  var tempErrors = this.normalizeErrors(errors);
  var messages = '';
  tempErrors.forEach(function (error) {
    messages += (messages ? '<br>' : '') + error.message;
  });
  this.updateIcon('icon-form-error');
  this.messageContainer.html(messages);
  this.expand('alert-error');
  this.initTimedClose(timedClose);
};

/**
 * Show success message to user
 *
 * @param {string} message - HTML or string to display
 * @param {integer} timedClose - the box will collapse after this amount of time
 */
NotificationBox.prototype.showSuccess = function showSuccess(message, timedClose) {
  this.messageContainer.html(message);
  this.updateIcon('icon-form-success');
  this.expand('alert-success');
  this.initTimedClose(timedClose);
};

/**
 * Show generic informational notice
 *
 * @param {string} message - HTML or string to display
 * @param {integer} timedClose - the box will collapse after this amount of time
 */
NotificationBox.prototype.showNotice = function showNotice(message, timedClose) {
  this.messageContainer.html(message);
  this.updateIcon('hidden');
  this.expand();
  this.initTimedClose(timedClose);
};
NotificationBox.prototype.initTimedClose = function initTimedClose(timedClose) {
  if (timedClose || this.options.timedClose) {
    var self = this;
    setTimeout(function () {
      self.collapse();
    }, timedClose || this.options.timedClose);
  }
};
module.exports = NotificationBox;
require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/node_modules/ui-notification-box/dist/ui-notification-box.less');